import React from 'react';

/**
 * WorkflowCanvas
 * A fixed, decorative n8n-style node graph that sits behind the whole page.
 * Nodes are connected by bezier "wires" with animated flowing dashes to
 * evoke data moving through an automation. Purely cosmetic + non-interactive.
 */
const WorkflowCanvas: React.FC = () => {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed inset-0 -z-10 overflow-hidden"
    >
      <svg
        className="h-full w-full opacity-[0.55]"
        viewBox="0 0 1440 900"
        preserveAspectRatio="xMidYMid slice"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient id="wireA" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#22e6ff" stopOpacity="0.0" />
            <stop offset="50%" stopColor="#22e6ff" stopOpacity="0.9" />
            <stop offset="100%" stopColor="#9d5cff" stopOpacity="0.2" />
          </linearGradient>
          <linearGradient id="wireB" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#ff3df0" stopOpacity="0.1" />
            <stop offset="50%" stopColor="#ff3df0" stopOpacity="0.8" />
            <stop offset="100%" stopColor="#2bffb0" stopOpacity="0.2" />
          </linearGradient>
          <linearGradient id="wireC" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#9d5cff" stopOpacity="0.1" />
            <stop offset="50%" stopColor="#9d5cff" stopOpacity="0.8" />
            <stop offset="100%" stopColor="#22e6ff" stopOpacity="0.2" />
          </linearGradient>
        </defs>

        {/* Connectors */}
        <path
          className="flow-line"
          d="M 150 200 C 320 200, 320 380, 520 380"
          stroke="url(#wireA)"
          strokeWidth="2.5"
        />
        <path
          className="flow-line fast"
          d="M 520 380 C 720 380, 720 180, 940 180"
          stroke="url(#wireC)"
          strokeWidth="2.5"
        />
        <path
          className="flow-line"
          d="M 940 180 C 1140 180, 1140 420, 1320 420"
          stroke="url(#wireB)"
          strokeWidth="2.5"
        />
        <path
          className="flow-line fast"
          d="M 200 640 C 420 640, 420 720, 660 720"
          stroke="url(#wireB)"
          strokeWidth="2.5"
        />
        <path
          className="flow-line"
          d="M 660 720 C 900 720, 900 560, 1180 560"
          stroke="url(#wireA)"
          strokeWidth="2.5"
        />
        <path
          className="flow-line"
          d="M 520 380 C 560 520, 600 600, 660 720"
          stroke="url(#wireC)"
          strokeWidth="2"
        />

        {/* Nodes */}
        {[
          { x: 110, y: 175, c: '#22e6ff' },
          { x: 480, y: 355, c: '#9d5cff' },
          { x: 900, y: 155, c: '#ff3df0' },
          { x: 1280, y: 395, c: '#2bffb0' },
          { x: 160, y: 615, c: '#ffb13d' },
          { x: 620, y: 695, c: '#22e6ff' },
          { x: 1140, y: 535, c: '#9d5cff' },
        ].map((n, i) => (
          <g key={i}>
            <rect
              x={n.x}
              y={n.y}
              width="78"
              height="50"
              rx="12"
              fill="#141633"
              stroke={n.c}
              strokeOpacity="0.7"
              strokeWidth="1.5"
            />
            <circle cx={n.x + 39} cy={n.y + 25} r="9" fill={n.c} fillOpacity="0.25" />
            <circle cx={n.x + 39} cy={n.y + 25} r="4" fill={n.c} />
            <circle cx={n.x} cy={n.y + 25} r="4" fill={n.c} />
            <circle cx={n.x + 78} cy={n.y + 25} r="4" fill={n.c} />
          </g>
        ))}
      </svg>
    </div>
  );
};

export default WorkflowCanvas;
